module.exports = __webpack_public_path__ + "img/2.ed948339.png";